import { render, staticRenderFns } from "./ModalPrivilege.vue?vue&type=template&id=8406a896"
import script from "./ModalPrivilege.vue?vue&type=script&lang=js"
export * from "./ModalPrivilege.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports